import { ACTION_CONSTANTS } from '../../actions/constants';
import { uuid } from 'util/baseUtil';

export class BaseReducer {
  constructor({ constantGroup, customState = {} }) {
    this.constantGroup = constantGroup;
    this.defaultContainers = () => {
      return {
        list: [],
        map: {},
        meta: {}
      };
    };
    this.initialState = this.defaultContainers();

    this.bucketCount = 5; // how many buckets to instantiate (increase if needed, but 5 seems more than enough)
    for (let i = 2; i <= this.bucketCount; i++) {
      this.initialState[i] = this.defaultContainers();
    }

    this._deleteQueue = []; // when temp creates need to be deleted, ids pushed in here
  }

  store = (state = this.initialState, action) => {
    switch (action.type) {
      case ACTION_CONSTANTS[this.constantGroup].mapPayload:
        return this.mapPayload({
          state,
          payload: action.payload,
          bucket: action.bucket,
          overwrite: action.overwrite
        });
      case ACTION_CONSTANTS[this.constantGroup].deletePayload:
        return this.deletePayload({
          state,
          payload: action.payload,
          bucket: action.bucket
        });
      case ACTION_CONSTANTS[this.constantGroup].clear:
        return this.clear({ state, bucket: action.bucket });
      default:
        return state;
    }
  };

  mapPayload({ state, payload, bucket, overwrite }) {
    let collection = payload.collection;
    let newState = JSON.parse(JSON.stringify(state));

    if (overwrite) {
      newState = this.clear({ state, bucket });
    }

    let activeBucket = bucket ? newState[bucket] : newState;

    activeBucket.meta = payload.meta || activeBucket.meta;

    // delete all temp creates
    this._deleteQueue.forEach(id => {
      delete activeBucket.map[id];
    });

    collection.forEach((model, i) => {
      //occasionally reponses will include deleted models bundled with created/updated
      if (model.is_deleted) {
        delete activeBucket.map[model.id];
      }

      // must be temp creating
      if (!model.id) {
        model.id = uuid();
        this._deleteQueue.push(model.id);
        activeBucket.map[model.id] = model;
      } else {
        activeBucket.map[model.id] = activeBucket.map[model.id] || {};
        Object.assign(activeBucket.map[model.id], model);
      }

      model.serverSeq = i;
    });

    activeBucket.list = Object.values(activeBucket.map).sort((a, b) => {
      return a.serverSeq - b.serverSeq;
    });

    return newState;
  }

  deletePayload = ({ state, payload, bucket }) => {
    let newState = JSON.parse(JSON.stringify(state));

    let activeBucket = bucket ? newState[bucket] : newState;

    payload.collection.forEach(model => {
      delete activeBucket.map[model.id];
    });
    activeBucket.list = Object.values(activeBucket.map).sort((a, b) => {
      return a.serverSeq - b.serverSeq;
    });

    return newState;
  };

  clear = ({ state, bucket }) => {
    const newState = JSON.parse(JSON.stringify(state));

    if (bucket) {
      newState[bucket] = this.defaultContainers();
    } else {
      Object.assign(newState, this.defaultContainers());
    }

    return newState;
  };
}



// WEBPACK FOOTER //
// ./src/reducers/util/baseReducer.js